var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "category" } }, [
    _c("header", { staticClass: "bg-cl-transparent py5 px20" }, [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c("breadcrumbs", {
            staticClass: "pl15",
            attrs: { withHomepage: true }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "row middle-sm m0" }, [
            _c("div", { staticClass: "col-sm-12" }, [
              _c("h1", { staticClass: "category-title h2 mb0 mt0" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.getCurrentCategory.meta_title ||
                        _vm.getCurrentCategory.name
                    ) +
                    "\n          "
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col-sm-4 align-right mt0 flex justify-content-end"
              },
              [
                _c(
                  "div",
                  { staticClass: "sorting" },
                  [
                    _c("label", { staticClass: "mr10" }, [
                      _vm._v(_vm._s(_vm.$t("Columns")) + ":")
                    ]),
                    _vm._v(" "),
                    _c("columns", { on: { "change-column": _vm.columnChange } })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "sorting ml10" },
                  [
                    _c("sort-by", {
                      attrs: {
                        "has-label": true,
                        value: _vm.getCurrentSearchQuery.sort
                      },
                      on: { change: _vm.changeFilter }
                    })
                  ],
                  1
                )
              ]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row m0" }, [
          _c(
            "button",
            {
              staticClass:
                "col-xs-5 mt25 mr15 p15 mobile-filters-button bg-cl-th-accent brdr-none cl-white h5 sans-serif fs-medium-small",
              on: { click: _vm.openFilters }
            },
            [_vm._v("\n          " + _vm._s(_vm.$t("Filters")) + "\n        ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mobile-sorting col-xs-6 mt25" },
            [
              _c("sort-by", {
                attrs: { value: _vm.getCurrentSearchQuery.sort },
                on: { change: _vm.changeFilter }
              })
            ],
            1
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container pb60" }, [
      _c("div", { staticClass: "row m0 pt15" }, [
        _c(
          "div",
          { staticClass: "col-md-3 start-xs category-filters" },
          [
            !_vm.isCategoryEmpty
              ? _c("sidebar", {
                  attrs: { filters: _vm.getAvailableFilters },
                  on: { changeFilter: _vm.changeFilter }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isCalculatorVisible
              ? _c("Box", {
                  class: _vm.isCategoryEmpty ? "mt0" : "mt30",
                  attrs: { box: _vm.box }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("cms-block-banner", {
              attrs: { identifier: "bs_LEFT", padding: "100%" }
            }),
            _vm._v(" "),
            _c("cms-block-banner", {
              attrs: { identifier: "bs_LEFT_2", padding: "100%" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.mobileFilters,
                expression: "mobileFilters"
              }
            ],
            staticClass: "col-md-3 start-xs mobile-filters"
          },
          [
            _c("div", { staticClass: "close-container absolute w-100" }, [
              _c(
                "i",
                {
                  staticClass: "material-icons p15 close cl-accent",
                  on: { click: _vm.closeFilters }
                },
                [_vm._v("close")]
              )
            ]),
            _vm._v(" "),
            _c("sidebar", {
              staticClass: "mobile-filters-body",
              attrs: { filters: _vm.getAvailableFilters },
              on: { changeFilter: _vm.changeFilter }
            }),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c(
              "button-full",
              {
                staticClass: "mb20 btn__filter",
                attrs: { categoryProps: _vm.getCurrentCategory.catalog },
                nativeOn: {
                  click: function($event) {
                    return _vm.closeFilters($event)
                  }
                }
              },
              [_vm._v("\n          " + _vm._s(_vm.$t("Filter")) + "\n        ")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-9 px10 border-box products-list" }, [
          _c(
            "div",
            {
              staticClass:
                "p20 brdr-1 brdr-cl-primary bg-cl-white products-list-container"
            },
            [
              _c(
                "p",
                { staticClass: "col-xs-12 end-md m0 pb20 cl-secondary" },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$t("{count} items", {
                          count: _vm.getCategoryProductsTotal
                        })
                      ) +
                      "\n          "
                  )
                ]
              ),
              _vm._v(" "),
              _vm.isCategoryEmpty
                ? _c(
                    "div",
                    { staticClass: "hidden-xs" },
                    [
                      _c("cms-block-chunk", {
                        attrs: { identifier: "c_404_TEXT" }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isLazyHydrateEnabled
                ? _c(
                    "lazy-hydrate",
                    { attrs: { "trigger-hydration": !_vm.loading } },
                    [
                      _c("product-listing", {
                        attrs: {
                          categoryProps: _vm.getCurrentCategory.catalog,
                          columns: _vm.defaultColumn,
                          products: _vm.getCategoryProducts,
                          isH4: false
                        }
                      })
                    ],
                    1
                  )
                : _c("product-listing", {
                    attrs: {
                      columns: _vm.defaultColumn,
                      products: _vm.getCategoryProducts,
                      isH4: false
                    }
                  })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "py30" },
            [
              _vm.getCurrentCategory.description != ""
                ? _c("category-description", {
                    staticClass: "px30",
                    attrs: { description: _vm.getCurrentCategory.description }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "relative pb20 pt15" }, [
      _c("div", {
        staticClass: "brdr-top-1 brdr-cl-primary absolute divider w-100"
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }